export * from '@fakturnia/components/highlight/public-api';
